<h1 matDialogTitle>Header Details</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <!-- <div fxFlex="75"> -->
        <mat-form-field fxFlex="75" width="100%">
          <mat-label>Reference</mat-label>
          <input matInput type="text" formControlName="orderReference">
        </mat-form-field>
      <!-- </div> -->

      <!-- <div fxFlex="25"> -->
        <mat-form-field fxFlex="25" width="100%">
          <mat-label>Version</mat-label>
          <input matInput type="text" formControlName="orderVersion">
        </mat-form-field>
      <!-- </div> -->

      <!-- <div fxFlex="100"> -->
        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Store</mat-label>
          <input matInput type="text" formControlName="storeName">
        </mat-form-field>
      <!-- </div> -->

      <!-- <div fxFlex="100"> -->
        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Salesperson</mat-label>
          <mat-select formControlName="salespersonCode">
            <mat-option *ngFor="let salesperson of salespersons" [value]="salesperson.code">
              {{salesperson.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      <!-- </div> -->
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Save</button>
</mat-dialog-actions>
